import { passwordCallbackRedirect } from "./passwordCallback";
const target = passwordCallbackRedirect(window.location.href);
if (target) window.history.replaceState(window.history.state, "", target);
